import { isPresent } from 'src/providers/common-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globals from './globals';
import { Injectable } from '@angular/core';

import { Subscriber, throwError } from 'rxjs';
import { RemoteRequest } from './remote-request';
import { AuthenticationService } from './authentication-service';
import { RemoteResponse } from './RemoteResponse';
import { Observable } from 'rxjs';
import { GeolocationService } from './providers/geolocation-service/geolocation-service';
import { ConnectionService } from './providers/connection-service/connection-service';
import { DeviceService } from './providers/device-service/device-service';
import { DeviceInfo } from './data/device-info';
import { SessionInfo } from './data/authentication-info';
import { SessionDataService } from './redux/session/session-data-service';
import { ToastController, Platform } from '@ionic/angular';
import { MessageDisplayUtil } from './message-display-utils';
import { map, catchError, distinctUntilChanged } from 'rxjs/operators';
import { AnyFn } from '@ngrx/store/src/selector';

/**
 * Created by Ashok on 30-03-2016.
 */
@Injectable()
export class RemoteHttpService {
  private root: string;
  private session: SessionInfo;
  constructor(
    // private http: Http,
    private authService: AuthenticationService,
    private sessionService: SessionDataService,
    private connService: ConnectionService,
    private deviceService: DeviceService,
    private geoService: GeolocationService,
    private toastCtl: ToastController,
    private platform: Platform,
    protected http: HttpClient
  ) {
    this.root = globals.MygolfServer;
    this.sessionService
      .getSession()
      .pipe(distinctUntilChanged())
      .subscribe((session: SessionInfo) => {
        this.session = session;
      });
  }

  /**
   * Ajax call
   * @param request The RemoteRequest which encapsulates all the remote call params
   * @param subscriber The subscriber to be called once the remote request returns
   * @param params Optional parameters. Usually this is used by the caller to identify
   * the the response. This params is returned along with the Response to identify
   * for which the response is returned
   */
  public call(request: RemoteRequest, subscriber?: Subscriber<RemoteResponse>, params?: any) {
    this.execute(request).subscribe(
      (resp: any) => {
        if (isPresent(subscriber) && isPresent(subscriber.next)) {
          subscriber.next(new RemoteResponse(resp, params));
        }
      },
      (error: any) => {
        if (subscriber && subscriber.error) {
          subscriber.error(error);
        }
      },
      () => {
        //The request completed. Any cleanup, you can do it here
        if (subscriber && subscriber.complete) {
          subscriber.complete();
        }
      }
    );
  }

  public execute(request: any, url?: string): Observable<Response> {
    if (url) {
      alert(url);
    }
    let hdrs = {};
    if (isPresent(this.session)) {
      hdrs[globals.AUTH_TOKEN_NAME] = this.session.authToken;
      // hdrs["username"] = session.username;
      if (request.headers && request.headers['Player-Id']) {
      } else {
        hdrs['Player-Id'] = this.session.playerId;
      }
      // hdrs["Player-Id"]             = this.session.playerId;
    }
    this.populateDeviceInfo(hdrs);
    let lat = this.geoService.getLatitude();
    let long = this.geoService.getLongitude();
    if (lat && long) {
      hdrs['Location-Latitude'] = lat;
      hdrs['Location-Longitude'] = long;
    }
    // hdrs['Referer'] = 'http://devlet.mygolf2u.com'
    let req: any = request.buildAjax(hdrs);
    let headers = new HttpHeaders();
    if (req.headers) {
      // console.debug('overriding request headers ', req.headers, headers, req, hdrs);
      req.headers.map(data => {
        if (data.value) {
          headers = headers.append(data.key.toString(), data.value.toString());
        }
      });
    }
    let observable;
    if (url) {
      observable = this.http.delete(url, req);
    } else if (
      req.url.indexOf('book-a-slot') > 0 ||
      req.url.indexOf('/generate-booking-bill') >= 0 ||
      req.url.indexOf('/mygolf2u-revenue/generate') >= 0 ||
      req.url.indexOf('/daily-report/generate') >= 0 ||
      req.url.indexOf('/booking-collection/generate') >= 0 ||
      req.url.indexOf('/daily-booking-statistics/generate') >= 0 ||
      req.url.indexOf('/daily-collection-report/generate') >= 0 ||
      req.url.indexOf('/daily-booking-payment/generate') >= 0 ||
      req.url.indexOf('/booking-revenue/generate') >= 0 ||
      req.url.indexOf('/mygolf2u-booking-stat/generate') >= 0 ||
      req.url.indexOf('/revenue-by-player-type/generate') >= 0 ||
      req.url.indexOf('/cashier-daily-summary/generate') >= 0 ||
      req.url.indexOf('/booking-revenue-detail/generate') >= 0 ||
      req.url.indexOf('/golfer-count/generate') >= 0 ||
      req.url.indexOf('/caddie-assignment/generate') >= 0 ||
      req.url.indexOf('/cancellation-report/generate') >= 0 ||
      req.url.indexOf('/booking-revenue-by-month/generate') >= 0 ||
      req.url.indexOf('/course-blocking/generate') >= 0 ||
      req.url.indexOf('/pricing-by-plan/generate') >= 0 ||
      req.url.indexOf('/discount-pricing/generate') >= 0 ||
      req.url.indexOf('/transaction/generate') >= 0 ||
      req.url.indexOf('/commission-claimed/generate') >= 0 ||
      req.url.indexOf('/manual-discount/generate') >= 0 ||
      req.url.indexOf('/component-usage/generate') >= 0 ||
      req.url.indexOf('/online-collection-settlement/generate') >= 0 ||
      req.url.indexOf('/revenue-settlement/generate') >= 0 ||
      req.url.indexOf('/pricing-by-player-type/generate') >= 0 ||
      req.url.indexOf('/cancellation-detail-report/generate') >= 0 ||
      req.url.indexOf('/generate-itemized-bill') >= 0 ||
      req.url.indexOf('/generate-statement-print') >= 0 ||
      req.url.indexOf('/import-template') >= 0 ||
      req.url.indexOf('/generate-order-print') >= 0 ||
      req.url.indexOf('/generate-booking-flight-labels') >= 0

    ) {
      observable = this.http.request(request.method, req.url, {
        body: req.body,
        headers,
        responseType: 'text',
      });
    } else if (req.url.indexOf('states-cities.json') >= 0) {
      observable = this.http.request(request.method, req.url, {
        body: req.body,
        headers,
        responseType: 'text',
      });
    } else {
      observable = this.http.request(request.method, req.url, {
        body: req.body,
        headers,
      });
    }
    return observable;
  }

  private populateDeviceInfo(hdrs: any) {
    let deviceInfo: DeviceInfo = this.deviceService.getCachedDeviceInfo();
    if (deviceInfo) {
      hdrs['Device-Id'] = deviceInfo.deviceId;
    }
  }

  /**
   * Converts a given data object to URL form
   * @param data The data
   * @returns {string}
   */
  toParam(data: any): string {
    let list = [];
    for (let i in data) {
      list.push(encodeURI(i) + '=' + encodeURIComponent(data[i]));
    }
    return list.join('&');
  }

  public handleError(error) {
    let result: any;
    // if(error) MessageDisplayUtil.showErrorToast(error.status, this.platform, this.toastCtl, 5000, "bottom");
    //Check whether the error is sent as header
    if (error && error.headers && error.headers.get) {
      result = error.headers.get('Error-Message');
    }
    if (!isPresent(result)) {
      if (error && error.json) {
        // result = error.json();
        result = error;
      } else if (error) {
        result = error;
      } else if (!this.connService.isConnected()) {
        result = 'Server call failed because your internet connection is down.';
      } else {
        result = 'Server call failed some unknown issue.';
      }
    }
    // return ErrorObservable.create(result);
    return throwError(result);
  }
}
